import { Button, Markdown } from '@components/ui';
import { useGetAuditDocumentQuery } from '@dieterApi/audit/useAuditDocumentQuery';
import { useGetAuditSummaryQuery } from '@dieterApi/audit/useAuditSummaryQuery';
import cx from 'classnames';
import { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

export function AuditSummary() {
  const [showFinalDocument, setShowFinalDocument] = useState(false);
  const {
    params: { applicationId },
  } = useRouteMatch<{ applicationId?: string }>();

  const { data: summaryData, loading: summaryLoading, error: summaryError } = useGetAuditSummaryQuery(applicationId);
  const { data: documentData, loading: documentLoading, error: documentError } = useGetAuditDocumentQuery(applicationId);

  const toggleView = () => {
    setShowFinalDocument(!showFinalDocument);
  };

  return (
    <div
      className={cx(
        'max-h-[95vh] max-w-[600px] fixed z-1240 overflow-hidden rounded-t-2xl md:shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.2)]',
        'w-full',
        'bg-white z-1000000',
        'bottom-0 right-0 '
      )}
    >
      <div className={'h-[80vh] p-8 overflow-y-scroll relative'}>
        <div className="text-lg font-medium mb-4">
          {showFinalDocument ? 'Generated Document' : 'Summary'}: {applicationId}
        </div>
        <div className="absolute top-4 right-4 flex space-x-2">
          <Button
            onClick={toggleView}
            btnColor="primary"
            className="text-sm"
          >
            {showFinalDocument ? 'Summary' : 'Document'}
          </Button>
        </div>
        {summaryLoading || documentLoading ? (
          <div>Loading...</div>
        ) : showFinalDocument ? (
          <div className="mt-4">
            <Markdown className="" text={documentData?.getAuditDocument?.document || ''} />
          </div>
        ) : (
          <div className="mt-4">
            <Markdown className="" text={summaryData?.getAuditSummary?.detailed || ''} />
          </div>
        )}
      </div>
    </div>
  );
}
